<template>
    <layout>
        <template v-slot:header>
            <AppHead title="Returns to Manufacturer" />
            <h2><i class="fas fa-truck-loading text-primary mr-2"></i>
                {{ manufacturer?.name || 'Unknown manufacturer' }}</h2>
            <flash-messages />
        </template>

        <template v-slot:default>
            <section class="mt-3 mb-5">
                <div v-if="manufacturer.pending_return_items.length" class="table-responsive">
                    <div class="row w-100">
                        <div class="col-md-12">
                            <jet-button class="btn btn-primary mb-3 float-right" btnStyle="success" @click="save"
                                :disabled="selectedItems.length == 0" :disable="form.processing">Create Return to
                                Manufacturer</jet-button>
                        </div>
                    </div>
                    <div>
                        <h3 class="text-center">Pending Items</h3>
                    </div>
                    <DataTable :value="manufacturer.pending_return_items" class="p-datatable-sm admin-datatable mx-3"
                        tableClass="border-left border-right border-bottom" dataKey="id" v-model:selection="selectedItems">
                        <Column class="px-2" selectionMode="multiple" headerStyle="width: 3rem"></Column>
                        <Column class="px-2 text-nowrap small px-1">
                            <template #body="slotProps">
                                <table>
                                    <ReturnItem :returnItem="slotProps.data" isManufacturerReturn="true" />
                                </table>
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div v-else class="pt-5">
                    <h3 class="text-center">No Pending Items for this Manufacturer</h3>
                </div>
                <div v-if="manufacturer.manufacturer_returns.length" class="pt-5">
                    <div class="text-center">
                        <h3 class="text-center">Completed Returns</h3>
                    </div>
                    <DataTable :value="manufacturer.manufacturer_returns" class="p-datatable-sm admin-datatable mx-3"
                        tableClass="border-left border-right border-bottom" dataKey="id"
                        @row-click="(e) => this.$inertia.visit(route('admin.products.view', [e.data.product.id]))">
                        <Column field="id" header="#" class="pl-3" headerClass="pl-3"></Column>
                        <Column field="created_at" header="Created">
                            <template #body="slotProps">
                                {{ moment(slotProps.data.created_at).format('M/D/YY LT') }}
                            </template>
                        </Column>
                        <Column field="items_count" header="Items"></Column>
                        <Column field="by_user_name" header="Created By"></Column>
                    </DataTable>
                </div>
                <div v-else class="pt-5">
                    <h3 class="text-center">No Returns Completed for this Manufacturer</h3>
                </div>
            </section>
        </template>
    </layout>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Admin/Layout'
import FlashMessages from '@/Shared/FlashMessages'
import moment from 'moment'
import SelectButton from 'primevue/selectbutton'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import JetButton from '@/Jetstream/Button'
import ReturnItem from '@/Components/Returns/ReturnItem'

export default {
    components: {
        Icon,
        Layout,
        SelectButton,
        FlashMessages,
        BreadCrumbs,
        JetButton,
        ReturnItem,
    },
    props: {
        manufacturer: Object,
    },
    data() {
        return {
            selectedItems: [],
            form: this.$inertia.form({
                items: []
            }),
        }
    },
    created() {
        this.moment = moment
    },
    mounted() { },
    methods: {
        save() {
            this.$confirm.require({
                message:
                    'Are you sure? This will close selected return items and download the return form.',
                header: 'Create a Return to Manufacturer',
                icon: null,
                acceptLabel: 'Yes',
                rejectLabel: 'Cancel',
                accept: () => {
                    this.form.processing = true
                    axios
                        .post(
                            this.route(
                                'admin.returns.manufacturer',
                                this.manufacturer?.id || 0
                            ),
                            {
                                items: this.selectedItems.map(v => {
                                    return { id: v.id }
                                })
                            },
                            {
                                responseType: 'blob'
                            }
                        )
                        .then(response => {
                            this.downloadResponse(response, 'return_form.xlsx')
                        })
                        .finally(() => {
                            this.form.processing = false
                            this.selectedItems = []
                            this.$inertia.reload({
                                only: ['items', 'histories']
                            })
                        })
                },
                reject: () => { }
            })
        },
        saveReturnItemNote($event, item) {
            this.$inertia.form({
                content: $event.target.value,
            }).put(this.route('admin.returns.manufacturer.item-addnote', [this.manufacturer.id, item.id]), {
                preserveScroll: true
            })
        },

        downloadForm(history) {
            this.downloadFile = true
            axios
                .post(
                    this.route('admin.returns.manufacturer.download', [history.id]),
                    {},
                    {
                        responseType: 'blob'
                    }
                )
                .then(response => {
                    this.downloadResponse(response, 'return_form.xlsx')
                })
                .finally(() => {
                    this.downloadFile = false
                })
        }
    }
}
</script>
